interface TaboolaFeedConfigType {
  containerId: string;
  placement: string;
}

export class TaboolaFeedConfig {
  static NEWS: TaboolaFeedConfigType = {
    placement: 'Below Article Thumbnails',
    containerId: 'taboola-below-article-thumbnails',
  };
  static STANDINGS: TaboolaFeedConfigType = {
    placement: 'Below Article Feed - Tabelle',
    containerId: 'taboola-below-article-feed---tabelle',
  };
}
